<template>
  <div class="layer cardEdit">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle">{{locale[settingTitle]}}</h2>
      <div class="talkEdit">
        <div class="talkCard">
          <!-- 타입 선택 -->
          <div class="types mb10">
            <button
              v-for="type in types"
              :key="type"
              type="button"
              class="btn sizeS toCapitalize"
              :class="{btnWhite: type !== activeType}"
              @click="setType(type)">
              {{locale[type]}}
            </button>
          </div>
          <!-- //타입 선택 -->
          <!-- 태그일 때 그룹 -->
          <button v-if="activeType === 'tag'" type="button" class="btnAddTag" @click="addTagGroup">
            + {{locale.add_tag_group}}
          </button>
          <!-- //태그일 때 그룹 -->
          <!-- 타입 모듈 리스트 -->
          <div v-if="moduleList.length > 0" class="typeModules">
            <draggable
              class="cardList"
              :list="moduleList"
              :group="{ name: activeType === 'tag' ? 'tagGroup' : 'moduleGroup', pull: 'clone', put: false }"
              :sort="false"
              :clone="onClone"
              draggable=".enabled">
              <div v-for="mod in moduleList"
                :key="mod.id"
                :class="{enabled: !(activeType === 'tag' && !content.find(x => x.type === 'tagGroup')) }"
                class="card">
                <!-- 카드 -->
                <div v-if="activeType === 'card'">
                  <div v-if="mod.img" class="thumb">
                    <img :src="mod.img" alt="">
                  </div>
                  <div v-if="mod.text2 && mod.text2.length > 0" class="text" v-html="mod.text2"></div>
                </div>
                <!-- //카드 -->
                <!-- 태그 -->
                <div v-else-if="activeType === 'tag'">
                  <div class="text">#{{mod.tag2}}</div>
                </div>
                <!-- //태그 -->
                <!-- 기타 -->
                <div v-else-if="activeType === 'etc'">
                  <div class="notransltate">
                    <div class="text">
                      <!-- userName -->
                      <div class="mb10">
                        <label class="label toCapitalize">{{locale.name}}</label>
                        <input type="text" class="input mt5" />
                      </div>
                      <!-- //userName -->
                      <!-- userPhone -->
                      <div class="mb10">
                        <label class="label toCapitalize">{{locale.telephone}}</label>
                        <input type="text" class="input mt5" />
                      </div>
                      <!-- //userPhone -->
                      <!-- userEmail -->
                      <div class="mb10">
                        <label class="label toCapitalize">{{locale.email}}</label>
                        <input type="text" class="input mt5">
                      </div>
                      <!-- //userEmail -->
                      <button type="button" class="btnTalk">{{locale.setting}}</button>
                    </div>
                  </div>
                </div>
                <!-- //기타 -->
              </div>
            </draggable>
          </div>
          <!-- //타입 모듈 리스트 -->
          <div v-else-if="activeType === 'card'">{{locale.nodata_talk_card}}</div>
          <div v-else-if="activeType === 'tag'">{{locale.nodata_talk_tag}}</div>
        </div>
        <!-- 미리보기 -->
        <div class="preview">
          <div id="cardList" class="cardList">
            <draggable
              tag="div"
              v-model="content"
              :animation="200"
              :options="{draggable: '.card'}"
              group="moduleGroup"
              style="height: 100%;">
              <transition-group type="transition"
                tag="div"
                style="min-height: 100%;">
                <div class="card"
                  v-for="(item, index) in content"
                  :key="index"
                  :class="{tagCard: item.type === 'tagGroup'}">
                  <!-- 카드 -->
                  <div v-if="item.type === 'card'">
                    <div v-if="item.img" class="thumb">
                      <img :src="item.img" alt="">
                    </div>
                    <div v-if="item.text2 && item.text2.length > 0" class="text" v-html="item.text2"></div>
                  </div>
                  <!-- //카드 -->
                  <!-- 태그 -->
                  <div v-else-if="item.type === 'tagGroup'">
                    <draggable
                      tag="div"
                      v-model="item.tag"
                      :animation="200"
                      group="tagGroup"
                      class="tags">
                      <div v-for="(tag, i) in item.tag" :key="i" class="tag">
                        #{{tag.tag2}}
                        <button type="button" class="btnDel" @click="delTag(index, i)"></button>
                      </div>
                    </draggable>
                    <p v-if="item.tag.length === 0" class="text">{{locale.message_add_tag}}</p>
                  </div>
                  <!-- //태그 -->
                  <!-- 기타 -->
                  <div v-else-if="item.type === 'userInfo'">
                    <div class="text">
                      <!-- userName -->
                      <div class="mb10">
                        <label class="label toCapitalize">{{locale.name}}</label>
                        <input type="text" class="input mt5" />
                      </div>
                      <!-- //userName -->
                      <!-- userPhone -->
                      <div class="mb10">
                        <label class="label toCapitalize">{{locale.telephone}}</label>
                        <input type="text" class="input mt5" />
                      </div>
                      <!-- //userPhone -->
                      <!-- userEmail -->
                      <div class="mb10">
                        <label class="label toCapitalize">{{locale.email}}</label>
                        <input type="text" class="input mt5">
                      </div>
                      <!-- //userEmail -->
                      <button type="button" class="btnTalk">{{locale.setting}}</button>
                    </div>
                  </div>
                  <!-- //기타 -->
                  <button type="button" class="btnDel" @click="delCard(index)"></button>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
        <!-- //미리보기 -->
      </div>
      <div class="btns">
        <button type="button" class="btn btnFull btnPrimary" @click="apply">{{locale.apply}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import UNIQUE from '@/common/unique'

export default {
  name: 'SettingEdit',
  props: [
    'locale',
    'lang',
    'activeTarget',
    'activeItem',
    'settingTitle',
    'cardList',
    'tagList'
  ],
  components: {
    draggable
  },
  computed: {
    moduleList () {
      const list = {
        card: this.cardList,
        tag: this.tagList,
        etc: this.etc
      }
      return list[this.activeType]
    },
    item () {
      const cardIds = this.cardList.map(x => x.id)
      const tagIds = this.tagList.map(x => x.id)
      return this.activeItem.filter(x => {
        return x.type === 'card' ? cardIds.includes(x.id) : x
      }).map(x => {
        const cardItem = x.type === 'card'
          ? this.cardList.find(c => c.id === x.id)
          : null
        const tagItem = x.type === 'tagGroup'
          ? { ...x,
            tag: x.tag.filter(c => tagIds.includes(c.id)).map(t => {
              return this.tagList.find(c => c.id === t.id)
            })
          }
          : null
        return x.type === 'userInfo'
          ? x
          : x.type === 'card'
            ? cardItem
            : x.type === 'tagGroup'
              ? tagItem
              : x
      })
    }
  },
  created () {
    if (this.item) {
      this.content = this._.cloneDeep(this.item)
    }
  },
  data () {
    return {
      content: [],
      types: [ 'card', 'tag', 'etc' ],
      activeType: 'card', // card, group, tag
      langValueLayer: false,
      langValue: {},
      etc: [
        { id: 'userInfo', type: 'userInfo', info: [ 'userName', 'userPhone', 'userEmail' ] }
      ], // userInfo, ...
      openCountry: false,
      searchCountry: '',
      countryList: [],
      tagGroup: {
        id: '',
        type: 'tagGroup',
        tag: []
      }
    }
  },
  methods: {
    setType (type) {
      this.activeType = type
    },
    toggleCountry (isOpen) {
      this.openCountry = isOpen
    },
    setSearchCountry () {
      const value = this.$refs.searchChatCountryInpu.value
      this.searchCountry = value
    },
    onClone (data) {
      const cloneData = this._.cloneDeep(data)
      // cloneData.id = UNIQUE.mid()
      return cloneData
    },
    addTagGroup () {
      const tagGroup = { ...this.tagGroup }
      tagGroup.id = UNIQUE.mid()
      this.content.push(tagGroup)
      setTimeout(() => {
        const cardList = document.getElementById('cardList')
        cardList.scrollTop = cardList.scrollHeight
      }, 100)
    },
    delTag (cardIndex, tagIndex) {
      if (window.confirm(this.locale.confirm_delete_talk_setting_tag)) {
        const card = this.content.find((x, index) => index === cardIndex)
        if (card) {
          card.tag = card.tag.filter((x, index) => index !== tagIndex)
        }
      }
    },
    delCard (index) {
      if (window.confirm(this.locale.confirm_delete_talk_setting_card)) {
        this.content = this.content.filter((x, i) => i !== index)
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel_talk_setting)) {
        this.$emit('cancel')
      }
    },
    apply () {
      const data = {
        target: this.activeTarget,
        id: this.item.id,
        data: this.content.filter(x => {
          return !(x.type === 'tagGroup' && x.tag && x.tag.length <= 0)
        })
      }
      if (window.confirm(this.locale.confirm_apply)) {
        this.$emit('apply', data)
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    height: 100%;
    max-width: 860px;
    background-color: $color-white;
  }
  .talkEdit {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
    flex: 1;
    position: relative;
    overflow: hidden;
    &:before {
      content: "\21E2";
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -1em;
      margin-left: -0.4em;
      font-size: 64px;
      font-weight: bold;
      font-family: sans-serif;
      line-height: 1;
      color: $color-lgrey2;
      transform: translate(-50%, -50%);
    }
  }
  .types {
    .btn + .btn {
      border-left: none;
    }
  }
  .talkCard {
    display: flex;
    flex-direction: column;
    width: 325px;
    overflow: hidden;
    .card:not(.enabled) {
      color: $color-lgrey;
      background-color: rgba($color-lgrey2, 0.5);
      cursor: not-allowed;
    }
  }
  .typeModules {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
  }
  .cardList {
    flex: 1;
    overflow: auto;
    height: 100%;
  }
  .card {
    position: relative;
    width: 320px;
    margin-bottom: 5px;
    white-space: pre-line;
    border: 1px solid $color-lgrey2;
    border-radius: 10px;
    background-color: $color-white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
    cursor: move;
    .btnDel {
      position: absolute;
      top: 0;
      right: 0;
      width: 30px;
      height: 30px;
      border-radius: 100%;
      background: rgba(255,255,255,0.5) url('~@/assets/img/ico_close_black.svg') 50% 50% / 12px no-repeat;
      opacity: 0.5;
      &:hover {
        opacity: 1;
      }
    }
    .thumb {
      display: flex;
      flex-direction: column;
      justify-content: center;
      max-height: 100px;
      border-radius: 8px 8px 0 0;
      overflow: hidden;
    }
    .text {
      padding: 15px;
    }
    &:hover {
      border-style: dashed;
      border-color: $color-grey;
    }
    .btnTalk {
      width: 100%;
      padding: 10px;
      border: 1px solid $color-lgrey2;
      border-radius: 10px;
      background-color: $bg-default;
      &.wh {
        background-color: $color-white;
      }
      .imgSend {
        width: 16px;
        margin-right: 5px;
        opacity: 0.25;
      }
    }
    .input {
      border-radius: 10px;
      border-color: $color-lgrey2 !important;
    }
  }
  .btnAddTag {
    width: 320px;
    margin-bottom: 5px;
    padding: 15px;
    border: 1px solid $color-lgrey2;
    border-radius: 10px;
    background-color: $color-white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  }
  .tags {
    padding-top: 5px;
    padding-left: 5px;
    min-height: calc(1.5em + 16px);
    .tag {
      display: inline-block;
      position: relative;
      margin-bottom: 8px;
      margin-right: 8px;
      padding: 8px 12px;
      text-align: left;
      white-space: nowrap;
      border-radius: 50px;
      background-color: $color-white;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
      .btnDel {
        top: -2px;
        right: -2px;
        width: 16px;
        height: 16px;
        background: $color-grey url('~@/assets/img/ico_close.svg') 50% 50% / 8px no-repeat;
      }
    }
  }
  .preview {
    position: relative;
    flex: none;
    width: 370px;
    margin-left: auto;
    padding: 15px;
    border:1px solid $color-lgrey;
    border-top-width:20px;
    border-radius: 10px 10px 0 0;
    background-color: $bg-default;
    .card {
      width: 330px;
      margin-bottom: 15px;
      &.tagCard {
        border: 2px dashed $color-lgrey;
        background: none;
        box-shadow: none;
        &:hover {
          border-color: $color-grey;
        }
        .text {
          color: $color-lgrey;
          text-align: center;
        }
      }
      .thumb {
        max-height: none;
      }
    }
    .tag {
      border: 1px solid $color-lgrey2;
      &:hover {
        border: 1px dashed $color-grey;
      }
    }
  }
}
</style>
